import { BaseService } from './BaseService';

/** A short-lived Azure Speech authorization token issued by the API. */
export interface SpeechTokenDto {
  /** Bearer token accepted by the Azure Speech service. */
  token: string;
  /** Azure Speech region (e.g. "eastus2"), when the server is configured with one. */
  region?: string | null;
  /** Custom Speech endpoint, when configured instead of a region. */
  endpoint?: string | null;
  /** ISO timestamp after which the token should not be used (request a fresh one). */
  expiresAt: string;
}

/**
 * Fetches short-lived Azure Speech authorization tokens for browser-side recognition. The Speech
 * subscription key never reaches the browser — only these ~10-minute tokens do.
 */
export class SpeechTokenService extends BaseService {
  async getToken(): Promise<SpeechTokenDto> {
    return this.post<SpeechTokenDto>('/v1/audio/speech-token');
  }
}

export const speechTokenService = new SpeechTokenService();
